import { combineReducers } from 'redux';
// import adminReducer from './adminReducer';
import chartReducer from './chartReducer';
import dataSetReducer from './dataSetReducer';
import alfredReducer from './alfredReducer';
import summaryReducer from './summaryReducer'
import adminReducer from './adminReducer'
import { reducer as formReducer } from 'redux-form'

export default combineReducers({
    summary: summaryReducer,
    form: formReducer,
    chart: chartReducer,
    dataSet: dataSetReducer,
    alfred: alfredReducer,
    admin: adminReducer
});

